/**
 * What the game draws for each art family until its .glb has loaded, and for any kind that fails
 * its checks: a simple shape of the same size, with colours. Every family in the manifest has one
 * (a test makes sure), so the game never draws a hole.
 */
import type * as THREE from 'three';

import { standInTree } from '../models/tree';

export const STAND_INS: Readonly<Record<string, () => THREE.BufferGeometry>> = {
  trees: standInTree,
};

const made = new Map<string, THREE.BufferGeometry>();

/** The stand-in of a family, made once and shared by its kinds. */
export function standIn(family: string): THREE.BufferGeometry {
  let geometry = made.get(family);
  if (!geometry) {
    const make = STAND_INS[family];
    if (!make) throw new Error(`no stand-in for the art family ${family}`);
    geometry = make();
    made.set(family, geometry);
  }
  return geometry;
}
